<div class="text-center">
  <a class="btn btn-primary" routerLink="/admin/actions/roles/add">Add Role</a>
</div>
<div>
  <app-base-report *ngIf="rolesData"
                   [hasCheckboxes]="false"
                   [rowActions]="rowActions"
                   [reportName]="'Manage Roles'"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="rolesData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChange($event)"
                   [tableLoading]="loading"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   (rowActionClicked)="actionsCB($event)"
                   [serviceInstance]="fetchRoles">
  </app-base-report>
</div>
